var _module = require('../../components/module');
var config = require('config');
var _ = require('lodash');

require('angular-ui-bootstrap/src/modal');
require('angular-input-masks');
require('../lr-touch');
require('../user');
require('../fullscreen-loading');
require('../thankyou-modal');
require('../analytics');
require('../activity-feed');
require('../../components/login');
require('../numbers-only');

_module.requires.push('ui.bootstrap.module.modal', 'ui.utils.masks');

_module.service('$loginOrRegisterModal', [
    '$log',
    '$http',
    '$location',
    '$timeout',
    '$uibModal',
    '$user',
    '$fsloading',
    '$thankyouModal',
    '$analytics',
    '$activityFeed',

    function $loginOrRegisterModal($log, $http, $location, $timeout, $uibModal, $user, $fsloading, $thankyouModal, $analytics, $activityFeed) {
        return function openLoginOrRegisterModal(opts) {
            opts = opts || {};
            var windowClass = 'login-or-register-modal';

            if(opts.hideRegistration) windowClass += ' hide-registeration';

            var modal = $uibModal.open({
                template: require('./index.html'),
                controller: [
                    '$scope',

                    function loginOrRegisterCtrl($scope) {
                        $log.debug('LOCATION', $location.absUrl());

                        $scope.hideRegistration = opts.hideRegistration || false;
                        $scope.registerationFormData = {};
                        $scope.loginOptions = {
                            autosubmit: _.get(opts, 'autosubmitLogin', false),
                            email: _.get(opts, 'email'),
                            phone: _.get(opts, 'phone')
                        };

                        if(opts.phone)
                            $scope.registerationFormData.phone = opts.phone;

                        // Functions
                        $scope.register = function register() {
                            $log.debug('register', $scope.registerationForm);

                            if($scope.registerationForm.$valid) {

                                var name = $scope.registerationFormData.name.split(' ');
                                var firstName = name.shift().trim();
                                var lastName = name.join(' ').trim();
                                var fullName = firstName + ' ' + lastName;
                                var phone = $scope.registerationFormData.phone;
                                var email = $scope.registerationFormData.email;

                                $user.first_name = firstName;
                                $user.last_name = lastName;
                                $user.full_name = fullName;
                                $user.phone = phone;
                                $user.email = email;
                                $user.account_type = 'unverified';

                                $fsloading.show();

                                $user.save()
                                    .then(function saveUserResponse() {
                                        $analytics.eventTrack('Nest User Registered', {
                                            'Consumer ID': $user.id,
                                            'Consumer Name': $user.first_name + ' ' + $user.last_name,
                                            'Consumer Email': $user.email,
                                            'Consumer Phone': $user.phone
                                        });

                                        $activityFeed.add({
                                            avatar: 'initials',
                                            type: 'lead',
                                            name: 'benoit_user_registration',
                                            userId: $user.affiliateId,
                                            meta: {
                                                benoitPartnerId: $user.affiliate.benoitPartnerId,
                                                benoitUserId: $user.id,
                                                name: $user.full_name,
                                                first_name: $user.first_name,
                                                last_name: $user.last_name,
                                                phone: $user.phone,
                                                email: $user.email
                                            }
                                        });

                                        createLead();

                                        $scope.$close('registered');
                                    })
                                    .catch(function saveUserError(err) {
                                        $log.error(err);

                                        alert(err.data.errors[0].detail);
                                    })
                                    .finally(function saveUserFinally() {
                                        $fsloading.hide();
                                    });
                            }
                        };

                        $scope.activationExpired = function activationExpired() {
                            openLoginOrRegisterModal(opts);
                        };

                        // Functions
                        function createLead() {
                            var data = {
                                applicant: {
                                    name: $user.full_name,
                                    email: $user.email || null,
                                    phone: $user.phone
                                },
                                meta: {
                                    benoitUserId: $user.id
                                },
                                ownerId: $user.affiliate.id,
                                source: 'nest.me Registration',
                                type: 'benoit'
                            };

                            if($user.affiliate.benoitPartnerId) {
                                data.vendorId = $user.affiliate.benoit_partner.vendorId;
                                data.vendorRepId = $user.affiliate.benoit_partner.id;
                                data.agentId = $user.affiliate.id;
                            } else {
                                data.vendorId = $user.affiliate.vendorId;
                                data.vendorRepId = $user.affiliate.id;
                            }

                            $http.post(config.listreportsUrl + '/v1/leads', data)
                                .then(function createLeadSuccess(response) {
                                    $log.debug('Lead Created Successfully', response.data);
                                })
                                .catch(function createLeadError(err) {
                                    $log.error('Create Lead Error', err.data);
                                });
                        }
                    }
                ],
                backdrop: true,
                windowClass: windowClass
            });

            modal.result.then(function onClose(response) {
                if(response === 'registered') {
                    $user.sendAccountVerification(opts.redirect || $location.absUrl());

                    return $thankyouModal('You will now receive a notification with a confirmation link. Once received through text or email, just click the link to verify your account. Please note: This link will expire in 24hrs.');
                } else if(opts.redirect) {
                    window.location = opts.redirect;
                }
            });

            return modal;
        };
    }
]);
